import { Controller } from "@hotwired/stimulus"

// Animates elements into view when scrolled into the viewport.
// Usage: data-controller="scroll-reveal"
//        data-scroll-reveal-target="item" on each element to animate
//        style="animation-delay: Xms" for stagger timing
export default class extends Controller {
  static targets = ["item"]

  connect() {
    this.setupObserver()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  setupObserver() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add("revealed")
          this.observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0.15 })

    this.itemTargets.forEach(item => {
      this.observer.observe(item)
    })
  }
}
